import BreakpointsEnum from '../enums/breakpointsEnum';
import {debounce} from 'lodash';
import 'jquery.cookie';
import 'mark.js/dist/jquery.mark';

let $headerActions = $('.header-actions'),
    $headerTop = $('.header-top'),
    $headerTopDropdownMenu = $('#headerTopDropdownMenu'),
    $searchForm = $('#searchForm'),
    $body = $('body'),
    prevScroll = $(window).scrollTop();

$(window).on('load scroll resize orientationchange', function () {
    let currentScroll = $(window).scrollTop();

    if (((window.App.getBreakpoint() === BreakpointsEnum.mobile && currentScroll > prevScroll) ||
         (window.App.getBreakpoint() !== BreakpointsEnum.mobile && currentScroll === 0) && $body.hasClass('fixed-header'))) {
        $body.removeClass('fixed-header');
    } else if (((window.App.getBreakpoint() === BreakpointsEnum.mobile && currentScroll < prevScroll) ||
                (window.App.getBreakpoint() !== BreakpointsEnum.mobile && currentScroll > 0)) && !$body.hasClass('fixed-header')) {
        $body.addClass('fixed-header');

        if ($headerTopDropdownMenu.is(':checked')) {
            $headerTopDropdownMenu.prop('checked', false);
        }
    }

    prevScroll = currentScroll;
});

$(document).click(function (e) {
    if (window.App.getBreakpoint() === BreakpointsEnum.tablet && $headerTopDropdownMenu.is(':checked')) {
        if ($headerTop.find('.dropdown').has(e.target).length === 0) {
            $headerTopDropdownMenu.prop('checked', false);
        }
    }

    if ($(document).has(e.target).length >= 1 && window.App.getBreakpoint() !== BreakpointsEnum.mobile && $searchForm.has(e.target).length === 0) {
        $headerActions.removeClass('search-focused');
    }
});

$(function () {
    let ajax = null;

    let App = window.App;
    App.search = {};

    let $searchInput = $searchForm.find('input[name="search"]');
    let $searchResult = $searchForm.find('.search-result');
    let $recentSearch = $searchForm.find('.recent-search');
    let $recentSearchList = $recentSearch.find('.recent-search-list');

    let recentSearchCookie = {
        cookieName: 'recent_search',
        recordCount: 3,

        draw: function () {
            let recentSearchList = state.recentSearchList;

            if (recentSearchList === undefined) {
                return false;
            }

            for (let element of recentSearchList) {
                $recentSearchList.append(`<div class="item">
                                            <a href="${element.url}">${element.title}</a>
                                            <svg onclick="App.search.removeRecentSearchItem($(this))">
                                                <use xlink:href="/foxfishing_v2/spritemap.svg#icon-close"></use>
                                            </svg>
                                        </div>`);
            }

            $recentSearch.attr('data-count', recentSearchList.length);
        },

        set: function (searchList) {
            $.cookie(this.cookieName, JSON.stringify(searchList), {expires: 7, path: '/'});
            $recentSearch.attr('data-count', searchList.length);
        },

        push: function (item) {
            let recentSearchList = state.recentSearchList;

            if (recentSearchList === undefined) {
                recentSearchList = [item];
            } else {
                if (recentSearchList.length === recentSearchCookie.recordCount) {
                    recentSearchList.pop();
                }

                recentSearchList.unshift(item);
            }

            recentSearchCookie.set(recentSearchList);
        },

        remove: function () {
            $.removeCookie(this.cookieName, {path: '/'});
            $recentSearchList.empty();
            $recentSearch.attr('data-count', 0);
        },

        check: function (url) {
            let recentSearchList = state.recentSearchList;

            if (recentSearchList === undefined) {
                return true;
            }

            return recentSearchList.findIndex(item => item.url === url) === -1;
        }
    }

    let state = {
        _recentSearchList: '',
        _searchText: '',

        set searchText(text) {
            this._searchText = text.trim();

            if (this._searchText.length === 0) {
                $searchResult.empty();
            }
        },

        get searchText() {
            return this._searchText;
        },

        get recentSearchList() {
            return $.cookie(recentSearchCookie.cookieName)
                ? $.parseJSON($.cookie(recentSearchCookie.cookieName))
                : undefined;
        }
    }

    recentSearchCookie.draw();

    $searchInput.focus(function () {
        $headerActions.addClass('search-focused');
    });

    App.search.onChange = debounce(function ($this) {
        state.searchText = $this.val();

        if ($this.val().trim().length === 0) {
            return false;
        }

        ajax = $.ajax({
            type: 'POST',
            url: $searchForm.attr('data-action-ajax'),
            data: {
                search: $this.val()
            },
            dataType: 'json',
            beforeSend: function () {
                if (ajax != null) {
                    ajax.abort();
                }
            },
            success: function (response) {
                if (response.search_results_view) {
                    $searchResult.html(response.search_results_view);
                    $searchResult.mark(state.searchText);
                }
            },
            complete: function () {
                ajax = null;
            }
        });
    }, 500);

    App.search.clearSearchTextField = function () {
        $searchInput.val('').trigger("input");
    }

    App.search.clearRecentSearchList = function () {
        recentSearchCookie.remove();
    }

    App.search.removeRecentSearchItem = function ($this) {
        let url = $this.siblings('a').attr('href');
        $this.parent().remove();
        $headerActions.addClass('search-focused');

        let searchResult = state.recentSearchList;
        let newSearchResult = searchResult.filter((item) => item.url !== url);

        recentSearchCookie.set(newSearchResult);
    }

    App.search.close = function () {
        $headerActions.removeClass('search-focused');
        App.search.clearSearchTextField();
    }

    App.search.open = function () {
        $headerActions.addClass('search-focused');
    }

    App.search.putItemInCookies = function ($this) {
        let url = $this.attr('href');

        if (recentSearchCookie.check(url)) {
            recentSearchCookie.push({
                title: $this.attr('title'),
                url
            });
        }
    }

    $searchForm.on('submit', function (e) {
        let search = $searchForm.find('input[name="search"').val().trim();

        if (!search.length) {
            e.preventDefault();
        }

        let url = $searchForm.attr('action') + `?search=${search}`;

        if (recentSearchCookie.check(url)) {
            recentSearchCookie.push({
                title: search,
                url
            });
        }
    });
});